/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type AsanaTaskEventQueryVariables = {
    orgRelayId: string;
    externalEventId: string;
    calendarId: string;
};
export type AsanaTaskEventQueryResponse = {
    readonly org: {
        readonly __typename: string;
        readonly id: string;
        readonly primaryOrgCalendar?: string | undefined;
        readonly forceFetchEventParentErrorable?: {
            readonly __typename: "EventParent";
            readonly id: string;
            readonly events: ReadonlyArray<{
                readonly eventKey: {
                    readonly externalEventId: string;
                };
                readonly organizer: {
                    readonly urnValue: string;
                } | null;
            }>;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        } | undefined;
    } | null;
};
export type AsanaTaskEventQuery = {
    readonly response: AsanaTaskEventQueryResponse;
    readonly variables: AsanaTaskEventQueryVariables;
};



/*
query AsanaTaskEventQuery(
  $orgRelayId: ID!
  $externalEventId: String!
  $calendarId: String!
) {
  org: node(id: $orgRelayId) {
    __typename
    id
    ... on Org {
      primaryOrgCalendar
      forceFetchEventParentErrorable(calendarId: $calendarId, externalEventId: $externalEventId) {
        __typename
        ... on EventParent {
          id
          events {
            eventKey {
              externalEventId
              id
            }
            organizer {
              urnValue
            }
          }
        }
        ... on Node {
          __isNode: __typename
          id
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "calendarId"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "externalEventId"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryOrgCalendar",
        "storageKey": null
    } as any, v7 = [
        {
            "kind": "Variable",
            "name": "calendarId",
            "variableName": "calendarId"
        } as any,
        {
            "kind": "Variable",
            "name": "externalEventId",
            "variableName": "externalEventId"
        } as any
    ], v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalEventId",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "concreteType": "Attendee",
        "kind": "LinkedField",
        "name": "organizer",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urnValue",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "AsanaTaskEventQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v3 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        (v5 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v6 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v7 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "forceFetchEventParentErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v5 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Event",
                                                    "kind": "LinkedField",
                                                    "name": "events",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EventKey",
                                                            "kind": "LinkedField",
                                                            "name": "eventKey",
                                                            "plural": false,
                                                            "selections": [
                                                                (v8 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v9 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "EventParent",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v2 /*: any*/),
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "AsanaTaskEventQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v3 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        (v5 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v6 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v7 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "forceFetchEventParentErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v5 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Event",
                                                    "kind": "LinkedField",
                                                    "name": "events",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EventKey",
                                                            "kind": "LinkedField",
                                                            "name": "eventKey",
                                                            "plural": false,
                                                            "selections": [
                                                                (v8 /*: any*/),
                                                                (v5 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v9 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "EventParent",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v5 /*: any*/)
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "2beed2890983d57ece8cc48014aacd73",
            "id": null,
            "metadata": {},
            "name": "AsanaTaskEventQuery",
            "operationKind": "query",
            "text": "query AsanaTaskEventQuery(\n  $orgRelayId: ID!\n  $externalEventId: String!\n  $calendarId: String!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    id\n    ... on Org {\n      primaryOrgCalendar\n      forceFetchEventParentErrorable(calendarId: $calendarId, externalEventId: $externalEventId) {\n        __typename\n        ... on EventParent {\n          id\n          events {\n            eventKey {\n              externalEventId\n              id\n            }\n            organizer {\n              urnValue\n            }\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '570bc5578e2d72acdb711306155bef1c';
export default node;
